import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AdminLayout() {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .adminMe()
      .then((m) => setEmail(m.email))
      .catch(() => navigate("/admin/login", { replace: true }))
      .finally(() => setLoading(false));
  }, [navigate]);

  if (loading) {
    return <div className="p-8 text-museum-muted">Checking session…</div>;
  }
  if (!email) return null;

  async function signOut() {
    await api.adminLogout();
    navigate("/admin/login", { replace: true });
  }

  return (
    <div className="min-h-screen flex flex-col bg-stone-50">
      <header className="bg-stone-900 text-white">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <Link to="/admin" className="font-serif text-lg whitespace-nowrap">
              HMM · Admin
            </Link>
            <nav className="flex items-center gap-4 text-sm">
              <NavLink
                to="/admin"
                end
                className={({ isActive }) =>
                  isActive ? "text-white" : "text-stone-400 hover:text-stone-200"
                }
              >
                Visit requests
              </NavLink>
              <NavLink
                to="/admin/donations"
                className={({ isActive }) =>
                  isActive ? "text-white" : "text-stone-400 hover:text-stone-200"
                }
              >
                Donations
              </NavLink>
              <NavLink
                to="/admin/users"
                className={({ isActive }) =>
                  isActive ? "text-white" : "text-stone-400 hover:text-stone-200"
                }
              >
                Admins
              </NavLink>
            </nav>
          </div>
          <div className="text-sm flex items-center gap-4">
            <span className="text-stone-300 hidden sm:inline">{email}</span>
            <button onClick={signOut} className="underline decoration-stone-500">
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-6xl mx-auto w-full px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
